export default __webpack_public_path__ + "static/media/noData.0b2a8ab9.jpg";